export enum ESelectionType {
    DISABLED = 0,
    BY_GROUPS = 1,
    BY_ELEMENTS = 2
}

export enum StartActionTypeEnum {
    SET_VIEW = 0,
    START_ANIMATION = 1
}
